"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attending = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Attending = function Attending() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    d: "M11.0041 0.333496C8.05744 0.333496 5.66872 2.72131 5.66872 5.66683C5.66872 7.08132 6.23083 8.43787 7.23141 9.43807C8.23198 10.4383 9.58905 11.0002 11.0041 11.0002C13.9507 11.0002 16.3394 8.61235 16.3394 5.66683C16.3394 2.72131 13.9507 0.333496 11.0041 0.333496Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M9.73438 20.3792C9.73438 20.8386 9.84857 21.2783 10.0535 21.6668H1.6672C1.20491 21.6654 0.776296 21.4248 0.53446 21.031C0.292625 20.6371 0.272052 20.1462 0.480089 19.7335L2.40082 15.8802C3.07947 14.5213 4.46946 13.6638 5.98884 13.6668H16.0193C17.3998 13.6641 18.6736 14.3718 19.4039 15.5205L16.139 18.8384L15.0958 17.8127L15.0887 17.8059C14.5564 17.2927 13.8529 17.0208 13.139 17.0208C12.424 17.0208 11.7218 17.294 11.1915 17.8038L10.5921 18.3782C10.0556 18.8907 9.73438 19.6084 9.73438 20.3792Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M22.7384 14.9833C23.0501 14.6937 23.5407 14.6937 23.8524 14.9833L23.8585 14.9889L24.4612 15.575C24.6125 15.7197 24.7001 15.9189 24.7001 16.1294C24.7001 16.3404 24.6121 16.5401 24.4602 16.6849L16.729 24.4748C16.5782 24.6201 16.3753 24.7003 16.1668 24.7003C15.9582 24.7003 15.7559 24.6207 15.6052 24.4754L11.9749 20.9353C11.8229 20.7905 11.7344 20.5903 11.7344 20.3792C11.7344 20.1682 11.8223 19.9685 11.9744 19.8237L12.5768 19.2463C12.7275 19.101 12.9305 19.0208 13.139 19.0208C13.3475 19.0208 13.5499 19.1004 13.7006 19.2457L16.1624 21.6661L22.7384 14.9833Z",
    fill: "currentColor"
  }));
};

exports.Attending = Attending;